import { CognitoUser, CognitoUserAttribute } from 'amazon-cognito-identity-js';
import { useState, useContext, useEffect, useRef } from 'react';
import axios from 'axios';
import API_BASE_URL from '../../utils/apiBaseUrl';
import { Button } from 'react-bootstrap';
import UserPool from './UserPool';
import { AccountContext } from './Account';
import LoginForm from './LoginForm/LoginForm';
import RegisterForm from './RegisterForm/RegisterForm'
import VerifyAccountForm from './VerifyAccountForm/VerifyAccountForm'
import './styles/login.css';
import ResetPasswordForm from './ResetPasswordForm/ResetPasswordForm';
import AlertModal from '../AlertModal/AlertModal';
import LoginTroubleModal from './LoginTroubleModal/LoginTroubleModal';
import ForgotUsernameForm from './ForgotUsernameForm/ForgotUsernameForm';
import ForgotUsernameModal from './ForgotUsernameModal/ForgotUsernameModal'

function Login({authmode, year}) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [otpEmail, setOtpEmail] = useState('');
  const [forgotUser, setForgotUser] = useState('');
  const [forgotPasswordVal, setForgotPasswordVal] = useState('');
  const [forgotEmailVal, setForgotEmailVal] = useState('');
  const [retrievedUsername, setRetrievedUsername] = useState('');
  const [showUsernameRetrievalModal, setShowUsernameRetrievalModal] = useState(false);

  const [forgotUserSecondTryIndex, setForgotUserSecondTryIndex] = useState(0)
  const [usernamesToRetry, setUsernamesToRetry] = useState([])

  const [newName, setNewName] = useState('');
  const [newUsername, setNewUsername] = useState('');
  const [newEmail, setNewEmail] = useState('');
  const [newPhoneNumber, setNewPhoneNumber] = useState('');
  const [newPassword, setNewPassword] = useState('');

  const [authMode, setAuthMode] = useState(authmode ?? 'signin');

  const [newSession, setNewSession] = useState(undefined);
  const [verifyProcess, setVerifyProcess] = useState(false);
  const [confirmationCode, setConfirmationCode] = useState('');
  const [forgotPassword, setForgotPassword] = useState(false);
  const [forgotUsername, setForgotUsername] = useState(false);
  const [enterUsername, setEnterUsername] = useState(true);
  const [isUsernameValid, setIsUsernameValid] = useState(true);

  const [showLoginAlertModal, setShowLoginAlertModal] = useState([false, '', ''])
  const [showPostLoginAlertModal, setShowPostLoginAlertModal] = useState([false, '', ''])
  const [returnToHomePage, setReturnToHomePage] = useState(false)
  const [showLoginTroubleModal, setShowLoginTroubleModal] = useState(false)
  const [passwordlessLogin, setPasswordlessLogin] = useState(true)
  const [validateOtp, setValidateOtp] = useState(false)
  const [otp, setOtp] = useState('')

  const [status, setStatus] = useState(false);
  const { authenticate, getSession, logout } = useContext(AccountContext);

  useEffect(() => {
    getSession(setNewSession)
      .then((session) => {
        console.log('Session Activated');
        setStatus(true);
      })
      .catch((err) => {
        console.log('Session: ', err);
        setStatus(false);
      });
  }, [status]);

  const changeAuthMode = () => {
    setAuthMode(authMode === 'signin' ? 'signup' : 'signin');
  }

  function setupNewUser() {
    axios.put(`${API_BASE_URL}/setup-new-user`, 
      {
        'username': newUsername,
        'fullname': newName,
        'email': newEmail,
        'phoneNumber': newPhoneNumber
      },
      {
        headers: {
            'Content-Type': 'application/json'
        },
        params: {year}
      }
    ).then((response) => {
      console.log('SET UP')
      setShowPostLoginAlertModal([true, `New user created: ${newUsername}`, 'Welcome to House of Paign!'])
    }).catch((error) => {
        console.log(error);
        setShowLoginAlertModal([true, 'Unable to set up new user. Please text 847-630-2489 to complete user setup.', 'We\'ve hit a snag'])
    })
  }

  const handleLogin =  (e) => {
    e.preventDefault();
    authenticate(username, password)
      .then((data) => {
        window.location.href='/enterPicks';
      })
      .catch((err) => {
        console.log(err);
        setShowLoginAlertModal([true, 'Login failure. Please contact the admin for a forgotten password.', 'We\'ve hit a snag'])
      });
  };

  const handlePasswordlessLogin = (e) => {
    e.preventDefault();
    axios.get(`${API_BASE_URL}/validate-otp`, 
      {
        headers: {
            'Content-Type': 'application/json'
        },
        params: {'otp': otp}
      }
    ).then((response) => {
      console.log('Valdiated OTP. Now authenticating.')
      const passwordlessUsername = response['data']['username']
      authenticate(passwordlessUsername + '-passwordless', 'Illini1!')
      .then((data) => {
        window.location.href='/enterPicks';
      })
      .catch((err) => {
        console.log(err);
        setShowLoginAlertModal([true, 'Login failure. Please contact the admin for a forgotten password.', 'We\'ve hit a snag'])
      });
    }).catch((error) => {
        console.log(error);
        setShowLoginAlertModal([true, 'Could not get username. Please contact the admin.', 'We\'ve Hit a Snag'])
    })

    
  }

  const handleRegister = (e) => {
    e.preventDefault();
    const attributeList = [];
    attributeList.push(
      new CognitoUserAttribute({
        Name: 'email',
        Value: newEmail,
      })
    );

    attributeList.push(
      new CognitoUserAttribute({
        Name: 'name',
        Value: newName,
      })
    );

    attributeList.push(
      new CognitoUserAttribute({
        Name: 'phone_number',
        Value: '+1' + newPhoneNumber,
      })
    );

    UserPool.signUp(newUsername, newPassword, attributeList, null, (err, data) => {
      if (err) {
        console.log(err);
        setShowLoginAlertModal([true, 'Could not sign up. Please make sure all fields are filled out and password has at least 8 characters, including uppercase and lowercase letters, a number and a special character.', 'We\'ve hit a snag'])
      } else {
        UserPool.signUp(newUsername + '-passwordless', 'Illini1!', attributeList, null, (err, data) => {
          if (err) {
            console.log(err);
            setShowLoginAlertModal([true, 'Could not sign up. Please make sure all fields are filled out and password has at least 8 characters, including uppercase and lowercase letters, a number and a special character.', 'We\'ve hit a snag'])
          } else {
            // setVerifyProcess(true);
            authenticate(newUsername, newPassword)
              .then((data) => {})
            setAuthMode('login')
            // setShowLoginAlertModal([true, 'User has been added.', 'Success'])
            setupNewUser();
          }
        })
      }
    });

    // TO-DO: API, need to create the relevant user and all of the default values
  };

  const handleVerify = (e) => {
    e.preventDefault();
    const user = new CognitoUser({
      Username: newUsername,
      Pool: UserPool,
    });
    user.confirmRegistration(confirmationCode, true, (err, data) => {
      if (err) {
        console.log(err);
        setShowLoginAlertModal([true, 'Could not verify account. Please contact the admin.', 'We\'ve Hit a Snag'])
      } else {
        authenticate(newUsername, newPassword)
          .then((data) => {
            window.location.href='/enterPicks';
          })
      }
    });
  };

  const getUsername = () => {
    console.log(forgotEmailVal)
    axios.get(`${API_BASE_URL}/get-username`, 
      {
        headers: {
            'Content-Type': 'application/json'
        },
        params: {'email': forgotEmailVal}
      }
    ).then((response) => {
      console.log(response['data']['username'])
      setRetrievedUsername(response['data']['username'])
      setShowUsernameRetrievalModal(true)
    }).catch((error) => {
        console.log(error);
        setShowLoginAlertModal([true, 'Could not get username. Please contact the admin.', 'We\'ve Hit a Snag'])
    })
  }

  const handleForgotPassword = (e) => {
    e.preventDefault();
    const user = new CognitoUser({
      Username: forgotUser,
      Pool: UserPool,
    });
    user.confirmPassword(confirmationCode, forgotPasswordVal, {
        onSuccess: () => {
          setReturnToHomePage(true)
          setShowLoginAlertModal([true, 'Password has been reset.', 'Success'])
        },
        onFailure: (err) => {
          console.log(err);
          setShowLoginAlertModal([true, 'Could not send verification code. Please make sure all fields are filled out and password has at least 8 characters, including uppercase and lowercase letters, a number and a special character. If you have tried more than 3 times, please wait 15 minutes and try again.', 'We\'ve Hit a Snag'])
        }
      }
    );
  };  

  const sendConfirmationCode = (e) =>  {
    if(forgotUser.length < 1) {
      setIsUsernameValid(false);
      return;
    }

    e.preventDefault();
    const user = new CognitoUser({
      Username: forgotUser,
      Pool: UserPool,
    });
    
    user.forgotPassword(
      {
        onSuccess: () => {
          console.log('forgot password')
          setEnterUsername(false);
        },
        onFailure: (err) => {
          console.log(err)
          setShowLoginAlertModal([true, 'Could not send verification code. Please refresh and try again.', 'We\'ve Hit a Snag'])
        },
      }
    );
  }

  const didMount = useRef(false);
  useEffect(() => {

    if (didMount.current) {
      resendConfirmationCode(forgotUser, forgotUserSecondTryIndex)
    } else {
      didMount.current = true
    }
    
  }, [forgotUserSecondTryIndex]);

  useEffect(() => {
    const snakeCaseUpper = forgotUser.replace(/^_*(.)|_+(.)/g, (forgotUser, c, d) => c ? c.toUpperCase() : '_' + d.toUpperCase())
    const snakeCaseLower = forgotUser.replace(/^_*(.)|_+(.)/g, (forgotUser, c, d) => c ? c.toLowerCase() : '_' + d.toLowerCase())
    const camelCaseOptions = [forgotUser.toLowerCase(), (forgotUser.charAt(0).toUpperCase() + forgotUser.slice(1)), snakeCaseUpper, snakeCaseLower ]

    const uniqueOptions = [...new Set(camelCaseOptions)]
    setUsernamesToRetry(uniqueOptions)
  }, [forgotUser])

  const resendConfirmationCode = (username, index) => {
    if (index >= usernamesToRetry.length){
      setEnterUsername(false);
      return
    }
    
    const id = usernamesToRetry[index]
    console.log(id)
    const user = new CognitoUser({
      Username: id,
      Pool: UserPool,
    });
  
    user.forgotPassword(
      {
        onSuccess: () => {
          setForgotUserSecondTryIndex(index + 1)
          return
        },
        onFailure: (err) => {
          setForgotUserSecondTryIndex(index + 1)
        },
      }
    );

  }

  const changeLoginMode = () => {
    setValidateOtp(false)
    const newLoginMode = !passwordlessLogin
    setPasswordlessLogin(newLoginMode)
  }

  const sendOtp = () => {
    console.log(otpEmail)
    axios.put(`${API_BASE_URL}/send-otp`, 
      {
        'email': otpEmail
      },
      {
        headers: {
            'Content-Type': 'application/json'
        },
      }
    ).then((response) => {
      setValidateOtp(true);
      console.log('SENT OTP')
    }).catch((error) => {
        console.log(error);
        setShowLoginAlertModal([true, 'Could not send one-time password. Please contact the admin.', 'We\'ve Hit a Snag'])
    })
  }

  const AuthModalRef = () => {

    let onHide;
    if (returnToHomePage) {
      onHide = ()=>{setShowLoginAlertModal([false, '', '']); setReturnToHomePage(false); window.location.href='/login';}
    } else {
      onHide = ()=>{setShowLoginAlertModal([false, '', '']);}
    }
    return (
      <AlertModal
        show={showLoginAlertModal[0]}
        onHide={onHide}
        modalTitle={showLoginAlertModal[2]}
        modalBody={showLoginAlertModal[1]}
        returnToHome
      /> 
    )
  }

  const RedirectModalRef = () => {

    console.log('GOT HERE AFTER ENROLLS')
    const onHide = ()=>{setShowPostLoginAlertModal([false, '', '']); setReturnToHomePage(false); window.location.href='/enterPicks';}
    
    return (
      <AlertModal
        show={showPostLoginAlertModal[0]}
        onHide={onHide}
        modalTitle={showPostLoginAlertModal[2]}
        modalBody={showPostLoginAlertModal[1]}
      /> 
    )
  }

  if(authMode === 'signup') {
    return (
      <>
        <RegisterForm
          newName={newName}
          newEmail={newEmail}
          newPhoneNumber={newPhoneNumber}
          newUsername={newUsername}
          newPassword={newPassword}
          setNewName={setNewName}
          setNewEmail={setNewEmail}
          setNewPhoneNumber={setNewPhoneNumber}
          setNewUsername={setNewUsername}
          setNewPassword={setNewPassword}
          changeAuthMode={changeAuthMode}
          handleRegister={handleRegister}
        />
        {/* <AuthModalRef/> */}
      </>

      )
    }

  if(verifyProcess) {
    return (
      <>
        <VerifyAccountForm
          confirmationCode={confirmationCode}
          setConfirmationCode={setConfirmationCode}
          handleVerify={handleVerify}
          isValid={true}
          formCaption={'A confirmation code has been sent to ' + newEmail}
          formPlaceholder='Enter confirmation code'
          submitCaption='Verify'
        />
        <AuthModalRef/>
      </>        
    )
  }

  // enter  email to prompt for confirmation code
  if(forgotPassword && enterUsername) {
    return (
      <>
        <VerifyAccountForm
          confirmationCode={forgotUser}
          setConfirmationCode={setForgotUser}
          handleVerify={sendConfirmationCode}
          isValid={isUsernameValid}
          formCaption='Username'
          formPlaceholder='Enter username'
          submitCaption='Submit'
        />
        <AuthModalRef/>
      </>
    )
  }

  // enter confirmation code
  if(forgotPassword && !enterUsername) {
    return (
      <>
        <ResetPasswordForm
          confirmationCode={confirmationCode}
          setConfirmationCode={setConfirmationCode}
          setNewPassword={setForgotPasswordVal}
          handleVerify={handleForgotPassword}
          isValid={true}
          formCaption={'A confirmation code has been sent to ' + forgotUser +'\'s email'}
          formPlaceholder='Enter confirmation code'
          submitCaption='Submit'
        />
        <AuthModalRef/>      
      </>  
    )
  }

  // enter confirmation code
  if(forgotUsername) {
    return (
      <>
        <ForgotUsernameForm
          handleSubmit={() => {getUsername()}}
          forgotEmailVal={forgotEmailVal}
          setForgotEmailVal={setForgotEmailVal}
        />
        <ForgotUsernameModal
          show={showUsernameRetrievalModal}
          onClose={()=>{setShowUsernameRetrievalModal(false); window.location.href = '/login'}}
          retrievedUsername={retrievedUsername}
        />
        <AuthModalRef/>
      </>
    )
  }
  
  if(!status) {
    return (
      <>
        <LoginForm
            username={username}
            password={password}
            otpEmail={otpEmail}
            setOtpEmail={setOtpEmail}
            setUsername={setUsername}
            setPassword={setPassword}
            changeAuthMode={changeAuthMode}
            getUsername={getUsername}
            handleLogin={handleLogin}
            handlePasswordlessLogin={handlePasswordlessLogin}
            setTroubleLoggingIn={()=>{setShowLoginTroubleModal(true)}}
            passwordlessLogin={passwordlessLogin}
            changeLoginMode={changeLoginMode}
            otp={otp}
            setOtp={setOtp}
            validateOtp={validateOtp}
            setValidateOtp={setValidateOtp}
            sendOtp={sendOtp}
        />
        <LoginTroubleModal
          show={showLoginTroubleModal}
          onClose={()=>{setShowLoginTroubleModal(false)}}
          setForgotPassword={() => {setForgotPassword(true)}}
          setForgotUsername={()=>{setForgotUsername(true)}}
        />
        <AuthModalRef/>
        <RedirectModalRef/>
      </>
    );
  }
  
  let welcomeText = newSession ? newSession['idToken']['payload']['name'] : 'unknown user';
  return (
    <div className='logged-in-section'>
        Hello, {welcomeText}
        <Button className='logout-button' onClick={logout}>Logout</Button>
    </div>
  )
}

export default Login;